import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';
import colors from '@olo-web/theme/colors';

export const LockImage = (props: IconProps): JSX.Element => (
  <Icon fill="none" {...props} viewBox="0 0 57 68">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.7">
        <path
          d="M40.9848 21.0747L6.83081 30.4637C3.05826 31.5008 0.822395 35.4904 1.83687 39.3747L7.34748 60.4743C8.36196 64.3586 12.2426 66.6668 16.0152 65.6297L50.1692 56.2406C53.9417 55.2036 56.1776 51.214 55.1631 47.3296L49.6525 26.2301C48.638 22.3458 44.7574 20.0376 40.9848 21.0747Z"
          stroke={colors.blackAlpha[300]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.4153 46.8701C31.3016 46.3516 32.4195 44.3568 31.9123 42.4146C31.405 40.4725 29.4647 39.3184 27.5784 39.8369C25.6922 40.3555 24.5742 42.3503 25.0815 44.2924C25.5887 46.2346 27.529 47.3887 29.4153 46.8701Z"
          stroke={colors.blackAlpha[300]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2432 29.5303L7.36784 18.5207C6.60524 15.6008 7.31322 12.4048 9.33603 9.63584C11.3588 6.86684 14.5308 4.75166 18.1541 3.75561C21.7774 2.75956 25.5552 2.96423 28.6565 4.3246C31.7578 5.68498 33.9285 8.08961 34.6911 11.0095L37.5664 22.019"
          stroke={colors.blackAlpha[300]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  </Icon>
);
